import { Route } from "@angular/router";
import { MutationComponent } from "./mutation.component";

export const MutationRouting: Route = {
  path: "mutation",
  component: MutationComponent,
  data: {
    breadcrumb: "Mutation"
  }
};
